<template>
  <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit">
    <el-tab-pane
      v-for="(item) in editableTabs"
      :key="item.title"
      :label="item.title"
      :name="item.name"
    >
      <el-form :model="item" label-width="120px">
        <el-form-item label="类型">
          <el-select v-model="item.pType">
            <el-option label="专利" value="专利"/>
            <el-option label="产品注册证" value="产品注册证" />
            <el-option label="知识产权" value="知识产权" />
            <el-option label="医疗器械经营许可证" value="医疗器械经营许可证" />
          </el-select>
        </el-form-item>
        <el-form-item label="信息">
          <el-input v-model="item.text" type="textarea" />
        </el-form-item>
        <el-form-item label="发证日期">
          <el-date-picker
            v-model="item.createDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="有效期至">
          <el-date-picker
            v-model="item.validDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(item)" :disabled="item.isSave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: {
    companyId: Number,
    propList: []
  },
  data () {
    return {
      editableTabsValue: '1',
      editableTabs: [],
      tabIndex: 0
    }
  },
  created () {
    // this.editableTabs = this.propList ? this.propList : []
    this.propList.forEach(prop => {
      let newTabName = ++this.tabIndex + ''
      this.editableTabs.push({
        title: '知识产权' + this.tabIndex,
        name: newTabName,
        text: prop.text,
        createDate: prop.createDate,
        validDate: prop.validDate && !(prop.validDate.indexOf('0000') > -1) ? prop.validDate : null,
        pId: prop.pId,
        pType: prop.pType,
        cId: prop.cId,
        isSave: false
      })
      this.editableTabsValue = newTabName
    })
    if (!(this.editableTabs.length > 0)) {
      this.addTab()
    } else {
      // console.log(this.propList)
      // console.log(this.editableTabs)
    }
  },
  methods: {
    addTab () {
      let newTabName = ++this.tabIndex + ''
      this.editableTabs.push({
        title: '知识产权' + this.tabIndex,
        name: newTabName,
        text: null,
        createDate: null,
        validDate: null,
        pId: 0,
        pType: null,
        cId: this.companyId,
        isSave: false
      })
      this.editableTabsValue = newTabName
    },
    handleTabsEdit (targetName, action) {
      // console.log(targetName)
      if (action === 'add') {
        this.addTab()
      }
      if (action === 'remove') {
        let tabs = this.editableTabs
        let activeName = this.editableTabsValue
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }
        this.editableTabsValue = activeName
        this.editableTabs.forEach(tab => {
          if (tab.name === targetName) {
            this.handleDel(tab).then(() => { this.editableTabs = tabs.filter(tab => tab.name !== targetName) })
          }
        })
      }
    },
    onSubmit (item) {
      // console.log(item)
      if (!item.text || !item.pType) {
        this.$message.error('类型和信息不能为空')
        return false
      }
      this.$http.post(this.apiUrl + '/sys/saveProperty', item)
        .then(response => {
          if (response.status === 200 && response.data && response.data.affectedRows > 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            item.pId = response.data.insertId
            item.isSave = true
          } else {
            this.$message.error('保存失败')
          }
        })
    },
    async handleDel (item) {
      const _this = this
      await this.$confirm('确认删除？')
        .then(() => {
          // done();
          // console.log(item)
          _this.$http.post(this.apiUrl + '/sys/delProperty', item)
            .then(response => {
              if (response.status === 200 && response.data && response.data.affectedRows > 0) {
                _this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                item.pId = response.data.insertId
                item.isSave = true
              } else {
                _this.$message.error('删除失败')
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/property.vue